import * as React from 'react';
import './popup.css';
import { withLocalize, Translate } from "react-localize-redux";
import { toast } from 'react-toastify';
const Loader = require('react-loader-spinner').default;

class CampaignUserLinks extends React.Component<any, any> {
  closePopup: any;

  constructor(props: any) {
    super(props);
    this.state = {
      updating: false,
      links: [],
      newLink: "",
      campaignId: 0,
      userId: 0
    }
    this.closePopup = this.props.closePopup
    this.loadCampaignUser = this.loadCampaignUser.bind(this)
  }


  componentDidMount() {
    this.setState({
      campaignId: this.props.campaignId,
      userId: this.props.userId
    }, () => {
      this.loadCampaignUser()
    })
  }

  loadCampaignUser() {
    fetch('campaigns/getCampaignUser', {
      method: 'POST',
      body: JSON.stringify({userId: this.state.userId, campaignId: this.state.campaignId})
    }).then(results => {
      return results.json();
    }).then(data => {
        let campaignUser = data.campaignUser
        let links = campaignUser.links
        this.setState({links})
    }).catch(err => {
      toast.error(err.message);
    })
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      campaignId: nextProps.campaignId,
      userId: nextProps.userId
    }, () => {
      this.loadCampaignUser()
    })
  }

  editLink(index: number, event:any) {
    let value = event.target.value
    let links = this.state.links
    links[index].link = value
    this.setState({links})
  }

  editNewLink(event:any) {
    let value = event.target.value
    this.setState({newLink: value})
  }

  addNewLink(event:any) {
    let link = {link: this.state.newLink}
    let links = this.state.links
    links.push(link)
    this.setState({links, newLink: ""})
  }

  updateLinks(event: any) {
    console.log(this.state.links)
    fetch('campaigns/editLink', {
      method: 'POST',
      body: JSON.stringify({
        links: this.state.links,
        userId: this.state.userId,
        campaignId: this.state.campaignId,
      })
    }).then(results => {
      this.closePopup()
    }).catch(err => {
      toast.error(err.message);
    })
  }



  public render() {
    return (
      <div id="popup-root" className="campaignUserLink">

      {this.state.updating && <div className="loadingDiv">
        <Loader
           type="Oval"
           color="#2d3444"
           height="100"
           width="100"
        />
      </div>}


          <i onClick={this.closePopup} className="fas fa-times"></i>

          <div className="container">
            <h2><Translate id="campaign.linkApproval" /></h2>
            {this.state.links.map((link: any, i:number) => {
              return <input readOnly={window.account.type!="admin"} key={i} type="text" placeholder={this.props.translate("campaign.link")} value={link.link} onChange={this.editLink.bind(this, i)} />
            })}

            {window.account.type=="admin" && <input className="newLink" type="text" placeholder={this.props.translate("campaign.link")} value={this.state.newLink} onChange={this.editNewLink.bind(this)} />}
            {window.account.type=="admin" && <i onClick={this.addNewLink.bind(this)} className="fas fa-plus"></i>}
            {window.account.type=="admin" && <button onClick={this.updateLinks.bind(this)} className="primary-btn"><Translate id="campaign.submitLinks" /></button>}
          </div>

      </div>
    )
  }

}

export default withLocalize(CampaignUserLinks)



// WEBPACK FOOTER //
// ./src/pages/campaign/popups/CampaignUserLinks.tsx